import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFilePdf,
  faFileImage,
  faFileAlt,
  faFileZipper,
} from "@fortawesome/free-solid-svg-icons";
import { modifyColor } from "../utils/helpers";

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  background: var(--color-secondary);
  border: 1px solid ${modifyColor(`var(--color-secondary)`, -40)};
  padding: 1rem;
  margin-bottom: 1rem;
  font-family: "Poppins Regular";
  margin: 0.5rem 0;

  a,
  span {
    text-decoration: none;
    font-weight: 600;
    margin-left: 1rem;
    color: var(--color-body-link);
    font-family: var(--font-links);
  }
  a {
    transition: all 0.5s ease;
    @media (hover: hover) {
      &:hover {
        text-decoration: underline;
      }
    }
  }
`;
const ButtonDownloadDiv = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
`;
const DownloadButton = styled.a`
  padding: 9px 25px 7px 25px;
  background: var(--color-primary);
  color: #fff !important;
  font-weight: 300 !important;
  border-radius: var(--border-radius);
  transition: all 0.5s ease;
  margin-left: 0 !important;
  @media (hover: hover) {
    &:hover {
      background-color: ${modifyColor(`var(--color-primary)`, 20)};
      text-decoration: none !important;
    }
  }
`;
const StyledIcon = styled(FontAwesomeIcon)`
  color: var(--color-primary);
`;

export default function FileDownload({
  url,
  showDownloadButton,
  fileName,
  downloadButtonText,
}) {
  return (
    <Wrapper>
      {url?.includes(".zip") ? (
        <StyledIcon icon={faFileZipper} size="2x" />
      ) : url?.includes(".png") || url?.includes(".jpg") ? (
        <StyledIcon icon={faFileImage} size="2x" />
      ) : url?.includes(".pdf") ? (
        <StyledIcon icon={faFilePdf} size="2x" />
      ) : (
        <StyledIcon icon={faFileAlt} size="2x" />
      )}
      {showDownloadButton == false ? (
        <a href={url}>{fileName}</a>
      ) : (
        <ButtonDownloadDiv>
          <span>{fileName}</span>
          <DownloadButton download href={url}>
            {downloadButtonText}
          </DownloadButton>
        </ButtonDownloadDiv>
      )}
    </Wrapper>
  );
}

FileDownload.propTypes = {
  fileName: PropTypes.string,
  url: PropTypes.string,
  showDownloadButton: PropTypes.bool,
  downloadButtonText: PropTypes.string,
};
